<template>
  <sModal
    v-model="modalShow"
    :cancel-text="$t('Common.Close')"
    content-class-name="file-modal"
    :mask-closable="false"
    :ok-text="$t('Common.Apply')">
    <ImportBlock
      :create-file-handler="createFileHandler"
      :disabled="!!loading"
      file_size="5"
      :files="fileFormat"
      files-types
      inline-style="width: 100%"
      :multiple="multiple"
      @deleteFile="deleteFile"/>
    <div
      key="footer"
      slot="footer">
      <sButton
        key="btn-apply"
        data-qa="btn-apply"
        @click="fileModalResult(true)">
        {{ $t('Common.Apply') }}
      </sButton>
      <sButton
        key="btn-close"
        data-qa="btn-close"
        type="text"
        @click="fileModalResult(false)">
        {{ $t('Common.Close') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import { QuestionFile } from '@/types/commonFile.js'

export default {
  name: 'modalDocumentAdd',
  data() {
    return {
      fileFormat: [],
      fileModal: [],
    }
  },
  methods: {
    deleteFile(index) {
      this.fileModal.splice(index, 1)
    },
    createFileHandler(files) {
      let resultFiles = null
      if (files) {
        resultFiles = Array.isArray(files) ? files[0] : files
      }
      if (resultFiles) {
        this.fileModal.push(resultFiles)
        if (this.multiple) {
          this.fileFormat.push(new QuestionFile( resultFiles ))
        } else {
          this.fileFormat = [new QuestionFile( resultFiles )]
        }
      } else {
        this.fileModal = []
        this.fileFormat = []
      }
    },
    fileModalResult(result) {
      if (result) {
        let result = []
        if (this.fileModal) {
          result = this.multiple ? this.fileModal : [this.fileModal]
        }
        this.$emit('update:files', result)
      }
      this.modalShow = false
    },
  },
  computed: {
    modalShow: {
      get: function () {
        return this.show
      },
      set: function (newValue) {
        this.$emit('update:show', newValue)
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            if (Array.isArray(this.files)) {
              this.files.forEach((file) => {
                this.createFileHandler(file)
              })
            } else {
              this.createFileHandler(this.files)
            }
          } else {
            this.createFileHandler( null)
          }
        }
      }
    }
  },
  props: {
    show: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    files: {
      type: Array
    },
    multiple: {
      type: Boolean
    },
  },
  components: {
    ImportBlock
  }
}
</script>
